import { useState } from "react";
import { CreditCardIcon, DownloadIcon, FleetIcon, TenantBuildingIcon, ZapIcon, TrendingUpIcon, FileTextIcon, CheckCircleIcon, ClockIcon, MapPinIcon, FilterIcon } from "../../../../../shared/cockpit/components/icons/Icon";
import "./BillingTenants.scss";

function BillingTenants() {
  const [activeTab, setActiveTab] = useState<"fleet" | "tenant">("fleet");

  const employees = [
    {
      id: "EMP-001",
      name: "Max Mustermann",
      vehicle: "ID.4 Pro",
      rfid: "DE-832-992",
      home: 342,
      public: 45,
      saving: "+124.50 €",
      status: "Ready for Payroll",
    },
    {
      id: "EMP-002",
      name: "Sarah Schmidt",
      vehicle: "Tesla Model Y",
      rfid: "DE-112-445",
      home: 512,
      public: 12,
      saving: "+189.20 €",
      status: "Ready for Payroll",
    },
    {
      id: "EMP-003",
      name: "Lukas Weber",
      vehicle: "Audi Q4 e-tron",
      rfid: "DE-551-223",
      home: 120,
      public: 230,
      saving: "+45.10 €",
      status: "Pending Review",
    },
    {
      id: "EMP-004",
      name: "Julia Meyer",
      vehicle: "BMW i4",
      rfid: "DE-998-112",
      home: 410,
      public: 0,
      saving: "+155.80 €",
      status: "Ready for Payroll",
    },
  ];

  const tenants = [
    {
      id: "OBJ-HAM-01",
      address: "Hafenstr. 12, Hamburg",
      tenant: "Müller, Klaus",
      meterId: "1SR-992-11",
      usage: 245,
      tariff: "27.00 ct/kWh",
      amount: "66.15 €",
      status: "Billed",
    },
    {
      id: "OBJ-BER-04",
      address: "Torstr. 55, Berlin",
      tenant: "Schneider, Anna",
      meterId: "1SR-442-88",
      usage: 189,
      tariff: "27.00 ct/kWh",
      amount: "51.03 €",
      status: "Pending",
    },
    {
      id: "OBJ-MUN-02",
      address: "Leopoldstr. 10, München",
      tenant: "Weber, Hans",
      meterId: "1SR-112-33",
      usage: 310,
      tariff: "26.50 ct/kWh",
      amount: "82.15 €",
      status: "Billed",
    },
    {
      id: "OBJ-ESS-09",
      address: "Rüttenscheider Str. 1, Essen",
      tenant: "Fischer, Lisa",
      meterId: "1SR-776-22",
      usage: 120,
      tariff: "27.00 ct/kWh",
      amount: "32.40 €",
      status: "Processing",
    },
  ];

  return (
    <div className="billing-view">
      <header className="billing-view__header">
        <div className="billing-view__header__content">
          <div className="billing-view__header__title--container">
            <div className="billing-view__header__icon-wrapper">
              <CreditCardIcon />
            </div>
            <h1 className="billing-view__header__title">Abrechnung & Operations</h1>
          </div>
          <p className="billing-view__header__subtitle">
            Automatisierte Abrechnung für Flotte (Mitarbeiter) und Immobilien
            (Mieterstrom).
          </p>
        </div>

        <div className="billing-view__header__toggle-group">
          <button
            className={`billing-btn ${activeTab === "fleet" ? "active" : ""}`}
            onClick={() => setActiveTab("fleet")}
          >
            <FleetIcon /> Flotte & Mitarbeiter
          </button>
          <button
            className={`billing-btn ${activeTab === "tenant" ? "active" : ""}`}
            onClick={() => setActiveTab("tenant")}
          >
            <TenantBuildingIcon /> Immobilien & Mieter
          </button>
        </div>
      </header>

      <div className="billing-view__stats">
        <div className="stat-card">
          <div className="stat-card__icon stat-card__icon--green">
            <TrendingUpIcon />
          </div>
          <div className="stat-card__info">
            <span className="stat-card__label">Einsparung vs. Public</span>
            <span className="stat-card__value">34.2%</span>
            <span className="stat-card__subtext green">
              Durch Home Charging
            </span>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-card__icon stat-card__icon--blue">
            <ZapIcon />
          </div>
          <div className="stat-card__info">
            <span className="stat-card__label">Geladene Energie (Monat)</span>
            <span className="stat-card__value">12.4 MWh</span>
            <span className="stat-card__subtext blue">Davon 85% Ökostrom</span>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-card__icon stat-card__icon--purple">
            <FileTextIcon />
          </div>
          <div className="stat-card__info">
            <span className="stat-card__label">Abrechnungs-Status</span>
            <span className="stat-card__value">Auto-Pilot</span>
            <span className="stat-card__subtext purple">
              Payroll Export Ready
            </span>
          </div>
        </div>
      </div>

      <div className="billing-view__content">
        <div className="content-header">
          <div className="content-header__title">
            {activeTab === "fleet" ? (
              <>
                <h2>Mitarbeiter-Ladeübersicht</h2>
                <p>RFID-Daten & Rückerstattung (Home Charging)</p>
              </>
            ) : (
              <>
                <h2>Mieterstrom-Abrechnung</h2>
                <p>Verbrauch & Tarife (Kapitalanlagen)</p>
              </>
            )}
          </div>
          <div className="content-header__actions">
            <button className="filter-btn">
              <FilterIcon /> Filter
            </button>
            {activeTab === "fleet" ? (
              <button className="export-btn">
                <DownloadIcon /> Export für Payroll
              </button>
            ) : (
              <button className="action-main-btn">
                <ZapIcon /> Rechnungen erstellen
              </button>
            )}
          </div>
        </div>

        <div className={`billing-table billing-table--${activeTab}`}>
          {activeTab === "fleet" ? (
            <>
              <div className="billing-table__header">
                <div className="billing-table__col">MITARBEITER</div>
                <div className="billing-table__col">FAHRZEUG & RFID</div>
                <div className="billing-table__col">HOME (KWH)</div>
                <div className="billing-table__col">PUBLIC (KWH)</div>
                <div className="billing-table__col">ERSPARNIS</div>
                <div className="billing-table__col">STATUS</div>
              </div>

              <div className="billing-table__body">
                {employees.map((emp) => (
                  <div key={emp.id} className="billing-table__row">
                    <div className="billing-table__col">
                      <div className="emp-info">
                        <span className="emp-info__name">{emp.name}</span>
                        <span className="emp-info__id">{emp.id}</span>
                      </div>
                    </div>
                    <div className="billing-table__col">
                      <div className="vehicle-info">
                        <span className="vehicle-info__name">
                          {emp.vehicle}
                        </span>
                        <span className="vehicle-info__rfid">
                          <CreditCardIcon /> {emp.rfid}
                        </span>
                      </div>
                    </div>
                    <div className="billing-table__col">
                      <span className="usage-value usage-value--home">
                        {emp.home}
                      </span>
                    </div>
                    <div className="billing-table__col">
                      <span className="usage-value usage-value--public">
                        {emp.public}
                      </span>
                    </div>
                    <div className="billing-table__col">
                      <span className="saving-value">{emp.saving}</span>
                    </div>
                    <div className="billing-table__col">
                      <span
                        className={`status-badge status-badge--${emp.status === "Pending Review" ? "pending" : "ready"}`}
                      >
                        {emp.status === "Pending Review" ? (
                          <ClockIcon />
                        ) : (
                          <CheckCircleIcon />
                        )}
                        {emp.status}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
              <div className="billing-table__header">
                <div className="billing-table__col">OBJEKT & ADRESSE</div>
                <div className="billing-table__col">MIETER</div>
                <div className="billing-table__col">ZÄHLER-ID</div>
                <div className="billing-table__col">VERBRAUCH (KWH)</div>
                <div className="billing-table__col">TARIF</div>
                <div className="billing-table__col">BETRAG</div>
                <div className="billing-table__col">STATUS</div>
              </div>

              <div className="billing-table__body">
                {tenants.map((tenant) => (
                  <div key={tenant.id} className="billing-table__row">
                    <div className="billing-table__col">
                      <div className="object-info">
                        <span className="object-info__id">{tenant.id}</span>
                        <span className="object-info__addr">
                          <MapPinIcon /> {tenant.address}
                        </span>
                      </div>
                    </div>
                    <div className="billing-table__col">
                      <span className="tenant-name">{tenant.tenant}</span>
                    </div>
                    <div className="billing-table__col">
                      <span className="meter-badge">{tenant.meterId}</span>
                    </div>
                    <div className="billing-table__col">
                      <span className="usage-main">{tenant.usage}</span>
                    </div>
                    <div className="billing-table__col">
                      <span className="tariff-link">{tenant.tariff}</span>
                    </div>
                    <div className="billing-table__col">
                      <span className="amount-value">{tenant.amount}</span>
                    </div>
                    <div className="billing-table__col">
                      <span
                        className={`status-pill status-pill--${tenant.status.toLowerCase()}`}
                      >
                        {tenant.status}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default BillingTenants;
